module.exports = __webpack_public_path__ + "media/personas/bg-emotions-9fb815b6.jpg";